/* eslint-disable
  eslint-comments/disable-enable-pair,
  security/detect-object-injection,
  complexity,
  max-lines-per-function,
  multiline-ternary,
  jsx-a11y/no-noninteractive-tabindex
*/
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from 'src/components/Autocomplete/AutocompleteList.scss';

import CardAccountDetails from '@mdi/svg/svg/card-account-details.svg';
import Briefcase from '@mdi/svg/svg/briefcase.svg';
import Tag from '@mdi/svg/svg/tag.svg';
import City from '@mdi/svg/svg/city.svg';
import Shield from '@mdi/svg/svg/shield.svg';
import Flag from '@mdi/svg/svg/flag.svg';
import HomeAccount from '@mdi/svg/svg/home-account.svg';
import History from '@mdi/svg/svg/history.svg';


const iconByType = {
  keyword: CardAccountDetails,
  employers: Briefcase,
  skills: Tag,
  workplace: City,
  regions: Shield,
  countries: Flag,
  remoteWork: HomeAccount
};

const getIconByType = (type) => {
  const Icon = iconByType[type];
  const classes = classNames(
    styles['autocomplete__item-icon'],
  );
  return (<Icon className={ classes } viewBox="0 0 24 24" />);
};

const labelToJSX = (label) => {
  const labelObject = typeof label === 'string' ? [{ part: label }] : label;
  return labelObject.map(({ part, highlight }, index) => {
    const key = `autocomplete-${part}-${index}`;
    return (
      <Fragment key={ key }>
        {highlight ? <span styleName="autocomplete__item--highlighted">{ part }</span> : part }
      </Fragment>
    );
  });
};

const AutocompleteList = ({
  sectionName, list, actions, selected, visible
}) => {
  const autocompleteList = list.map(({
    name, label, text, latest
  }, index) => {
    const isSelected = selected === index + 1;
    const insertDivider = !latest && name !== (list[index + 1] || {}).name;
    const lastItem = list.length <= index + 1;
    const selectItem = () => {
      actions.addTag(index + 1);
    };
    const autocompleteKey = `autocomplete-${name}-${(text || label)}-${index}`;
    const autocompleteDataTest = `autocomplete-${sectionName}-${latest ? 'latest' : name}`;

    return (
      <Fragment key={ autocompleteKey }>
        <li data-target="autocomplete-item" tabIndex="0">
          <button
            aria-hidden={ !visible }
            className={ classNames(
              styles.autocomplete__item,
              {
                [styles['autocomplete__item--selected']]: isSelected,
                [styles['autocomplete__item--latest']]: latest
              }
            ) }
            data-target="autocomplete-item"
            data-test={ autocompleteDataTest }
            onClick={ selectItem }
            tabIndex="-1"
            type="button"
          >
            {
              latest
                ? <History styleName="autocomplete__item-icon" viewBox="0 0 24 24" />
                : getIconByType(name)
            }
            { labelToJSX(label) }
          </button>
        </li>
        {insertDivider && !lastItem && <li className={ styles['autocomplete__item-divider'] } /> }
      </Fragment>
    );
  });

  const listDataTest = `autocomplete-${sectionName}-wrap`;

  return (
    <ul
      className={ classNames(
        styles.autocomplete,
        { [styles['autocomplete--open']]: visible }
      ) }
      data-test={ listDataTest }
    >
      { autocompleteList }
    </ul>
  );
};

const listProperties = PropTypes.shape({
  label: PropTypes.any,
  latest: PropTypes.bool,
  name: PropTypes.string,
  text: PropTypes.string
});

AutocompleteList.propTypes = {
  actions: PropTypes.shape({
    addTag: PropTypes.func
  }),
  list: PropTypes.arrayOf(listProperties),
  sectionName: PropTypes.string,
  selected: PropTypes.number,
  visible: PropTypes.bool
};

AutocompleteList.defaultProps = {
  actions: {},
  list: [],
  sectionName: '',
  selected: 1,
  visible: false
};

export default AutocompleteList;
